import { z } from 'zod'

export const ADMINFORMSREVISIONSPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminFormsRevisionsPostResponseSchema = z.unknown()
export type AdminFormsRevisionsPostResponse = z.infer<typeof adminFormsRevisionsPostResponseSchema>
